import { useMutation } from '@tanstack/react-query';
import * as Api from '../api';
import { useAuthContext } from '../context';

export const useVerifyPhoneSetup = () => {
  const {
    state: { user },
    methods: { setUser },
  } = useAuthContext();

  return useMutation({
    mutationFn: async (values: { code: string }) => {
      const { data } = await Api.VerifyPhoneSetup(values);
      return data;
    },
    onSuccess: (data) => {
      if (user) {
        setUser({ ...user, phone: data.phone, isPhoneVerified: data.isPhoneVerified });
      }
    },
  });
};
